import { useToast } from '@chakra-ui/react';
import CardFeesFormUI from '@Modules/cardManagementSystem/cardholder/components/forms/cardData/CardFeesFormUI';
import CardProductFormUI from '@Modules/cardManagementSystem/cardholder/components/forms/cardData/CardProductFormUI';
import CardProgramFormUI from '@Modules/cardManagementSystem/cardholder/components/forms/cardData/CardProgramFormUI';
import MagneticTapeApplicationFormUI from '@Modules/cardManagementSystem/cardholder/components/forms/cardData/MagneticTapeApplicationFormUI';
import MiscePerioFeesDataTableRowFormUI from '@Modules/cardManagementSystem/cardholder/components/forms/cardData/MiscePerioFeesDataTableRowFormUI';
import ReplacementFeesDataTableRowFormUI from '@Modules/cardManagementSystem/cardholder/components/forms/cardData/ReplacementFeesDataTableRowFormUI';
import CustomTabs from '@Modules/core/components/customTab/CustomTabs';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import CustomAppModal from '@Modules/core/components/modal/CustomModal';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { useMutation, useQuery } from '@tanstack/react-query';
import React from 'react';
import miscellaneousPeriodicFeesDataTableRowFormMeta from '../../../formHandler/miscPerioFeesDataTableRowFormMeta';
import replacementFeesDataTableRowFormMeta from '../../../formHandler/replacementFeesDataTableRowFormMeta';
import cardFeesFormMeta from './formMeta/cardFeesFormMeta';
import cardProductFormMeta from './formMeta/cardProductFormMeta';
import cardProgramFormMeta from './formMeta/cardProgramFormMeta';
import { mtaFormMetaObj } from './formMeta/magneticTapeApplication/magneticTapeApplicationFormMeta';
import { getMiscellaneousPeriodicFeesDataTableColumns, TMiscellaneousPeriodicFeesDataTableData } from './MiscellaneaousPeriodicFeesDataTableMeta';
import {
  getReplacementFeesDataTableColumns,
  TReplacementFeesDataTableData,
} from './ReplacementFeesDataTableMeta';

const tabHeaders = [
  'Application Bande Magnétique',
  'Frais Carte',
  'Frais Remplac.',
  'Frais Périodiques Divers',
];

export type TFeesTable = 'replacementFees' | 'miscellaneousPeriodicFees';

const CardProductMixedHandler = () => {
  const [replacementFeesRowDataTable, setReplacementFeesRowDataTable] =
    React.useState<TReplacementFeesDataTableData>({
      primaryKey: '',
      replacementReason: {
        code: '',
        codeName: '',
      },
      replacementFees: {
        code: '',
        codeName: '',
        amount: 0,
      },
    });

  const [miscePerioFeesRowDataTable, setMiscePerioFeesRowDataTable] =
    React.useState<TMiscellaneousPeriodicFeesDataTableData>({
      primaryKey: '',
      id: '',
      name: '',
    });

  const replacementFees = [React.useRef<any>(null), React.useRef<{
    submitBtnRef: React.MutableRefObject<any>,
  }>(null)];
  const miscellaneousPeriodicFees = [React.useRef<any>(null), React.useRef<{
    submitBtnRef: React.MutableRefObject<any>,
  }>(null)];
  const editModalRef = {
    replacementFees: replacementFees[0],
    miscellaneousPeriodicFees: miscellaneousPeriodicFees[0]
  };

  // const formModalRef = React.useRef<{
  //   submitBtnRef: React.MutableRefObject<any>,
  // }>(null);
  const formModalRef = {
    replacementFees: replacementFees[1],
    miscellaneousPeriodicFees: miscellaneousPeriodicFees[1]
  };

  const toast = useToast();

  //   Initialize react Query to GET Data
  const queryKey = ['CardProduct'];
  const { data, isLoading } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      // TODO: Replace this by your fetcher function
      return new Promise(function (resolve) {
        setTimeout(() => resolve('data'), 5000);
      });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const { isLoading: isSubmitting } = useMutation(async () => {}, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    /*try {
            await mutateAsync();
        } catch (error) {
            console.log(error);
        }*/
  };

  const handleEdit = (row: any, feesTableName: TFeesTable) => {
    feesTableName === 'replacementFees' ? setReplacementFeesRowDataTable(row.original) : setMiscePerioFeesRowDataTable(row.original);

    editModalRef[feesTableName]?.current?.onOpen();
  };

  const replacementFeesColumns = getReplacementFeesDataTableColumns({
    isLoading,
    handleEdit,
  });

  const miscePerioFeesColumns = getMiscellaneousPeriodicFeesDataTableColumns({
    isLoading,
    handleEdit,
  });

  const triggerSubmit = (feesTableName: TFeesTable) => {
    formModalRef[feesTableName]?.current?.submitBtnRef?.current?.click();
  };

  const onModalFormSubmit = async (payload: any) => {
    console.log('Modal payload: ', payload);
  };

  const tabContents = React.useMemo(
    () => [
      <MagneticTapeApplicationFormUI meta={mtaFormMetaObj} isLoading={isLoading} />,
      <CardFeesFormUI meta={cardFeesFormMeta} isLoading={isLoading} />,
      <>
        <CustomReactTable
          data={data || [{}, {}, {}]}
          columns={replacementFeesColumns}
          hasPagination={false}
        />

        <CustomAppModal
          title="Editer"
          ref={editModalRef.replacementFees}
          actionBtn={
            <CustomSaveBtn
              isLoading={isLoading}
              isSubmitting={isSubmitting}
              onClick={() => triggerSubmit('replacementFees')}
            />
          }
          actionBtnText={'Valider'}
          size="3xl"
          isCentered
          closeOnOverlayClick={false}
        >
          <ReplacementFeesDataTableRowFormUI
            data={replacementFeesRowDataTable}
            meta={replacementFeesDataTableRowFormMeta}
            onSubmit={onModalFormSubmit}
            isLoading={isLoading}
            isSubmitting={isSubmitting}
            ref={formModalRef.replacementFees}
          />
        </CustomAppModal>
      </>,
      <>
        <CustomReactTable
          data={data || [{}, {}, {}]}
          columns={miscePerioFeesColumns}
          hasPagination={false}
        />

        <CustomAppModal
          title="Editer"
          ref={editModalRef.miscellaneousPeriodicFees}
          actionBtn={
            <CustomSaveBtn
              isLoading={isLoading}
              isSubmitting={isSubmitting}
              onClick={() => triggerSubmit('miscellaneousPeriodicFees')}
            />
          }
          actionBtnText={'Valider'}
          size="3xl"
          isCentered
          closeOnOverlayClick={false}
        >
          <MiscePerioFeesDataTableRowFormUI
            data={miscePerioFeesRowDataTable}
            meta={miscellaneousPeriodicFeesDataTableRowFormMeta}
            onSubmit={onModalFormSubmit}
            isLoading={isLoading}
            isSubmitting={isSubmitting}
            ref={formModalRef.miscellaneousPeriodicFees}
          />
        </CustomAppModal>
      </>,
    ],
    [isLoading, isSubmitting]
  );

  return (
    <>
      <CardProductFormUI
        meta={cardProductFormMeta}
        onSubmit={onSubmit}
        isLoading={isLoading}
        isSubmitting={isSubmitting}
      >
        <CardProgramFormUI meta={cardProgramFormMeta} isLoading={isLoading} />

        <CustomTabs tabHeaders={tabHeaders} tabContents={tabContents} isLazy={false} />
      </CardProductFormUI>
    </>
  );
};

export default CardProductMixedHandler;
